<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <div
      id="creategrouprecord"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{$t("new_rec")}}
            </h5>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="createRecord">
              <div class="form-group">
                <label>{{$t("rec_name")}}</label>
                <input
                  type="text"
                  name="name"
                  v-model="name"
                  class="form-control"
                  required
                />
              </div>
              <!-- <div class="form-group">
                <label>Start</label>
                <div class="flex">
                  <input
                    type="date"
                    name="startdate"
                    v-model="startdate"
                    class="form-control"
                    required
                  />
                  <input
                    type="time"
                    name="starttime"
                    v-model="starttime"
                    class="form-control"
                    required
                  />
                </div>
              </div> -->

              <div v-if="!manualStartRecord" class="form-group">
                <label>{{$t("start")}}</label>
                <div class="flex">
                  <input
                    type="date"
                    name="startdate"
                    v-model="startdate"
                    class="form-control"
                    :min="new Date().toISOString().slice(0, 10)"
                    required
                  />
                  <input
                    type="time"
                    name="starttime"
                    v-model="starttime"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <p v-if="!manualStartRecord" class="">{{$t("or")}}</p>

              <div class="form-group" style="display:flex; align-items:center;">
                <input
                  id="startcheckbox"
                  @change="showStartdate"
                  type="checkbox"
                  checked
                />
                <span class="ml-2">{{$t("start_rec")}}</span>
              </div>

              <div v-if="!manualEndRecord" class="form-group">
                <label>{{$t("end")}}</label>
                <div class="flex">
                  <input
                    type="date"
                    name="enddate"
                    v-model="enddate"
                    class="form-control"
                    required
                  />
                  <input
                    type="time"
                    name="endtime"
                    v-model="endtime"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <p v-if="!manualEndRecord" class="">{{$t("or")}}</p>

              <div class="form-group" style="display:flex; align-items:center;">
                <input
                  id="endcheckbox"
                  @change="showEnddate"
                  type="checkbox"
                  checked
                />
                <span class="ml-2">{{$t("end_rec")}}</span>
              </div>

              <div
                class="form-group"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{$t("cancel")}}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{$t("create_rec")}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

export default {
  name: "CreateGroupRecord",
  components: {
    Loading,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      name: "",
      startdate: "",
      starttime: "",
      enddate: "",
      endtime: "",
      manualEndRecord: true,
      manualStartRecord: true,
      mssg: "",
      Errormssg: "",
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["createGroupRecord", "fetchGroupRecords"]),
    onCancel() {
      this.$emit("closeGroupRecordModal");
    },
    showStartdate() {
      let startcheckbox = document.getElementById("startcheckbox");
      if (!startcheckbox.checked) {
        this.manualStartRecord = false;
      } else {
        this.manualStartRecord = true;
        this.startdate = this.starttime = "";
      }
    },
    showEnddate() {
      let endcheckbox = document.getElementById("endcheckbox");
      if (!endcheckbox.checked) {
        this.manualEndRecord = false;
      } else {
        this.manualEndRecord = true;
        this.enddate = this.endtime = "";
      }
    },
    createRecord() {
      this.isLoading = true;
      let newrecord = {
        name: this.name,
      };
      if (this.enddate) {
        newrecord.end = `${this.enddate.replace(/-/g, "/")} ${this.endtime}`;
      }
      if (this.startdate) {
        newrecord.start = `${this.startdate.replace(/-/g, "/")} ${
          this.starttime
        }`;
      }
      this.createGroupRecord({ id: this.$route.params.id, newrecord })
        .then((res) => {
          setTimeout(() => {
            this.fetchGroupRecords({ id: this.$route.params.id }).then(() => {
              this.onCancel();
            });
          }, 1000);
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style></style>
<i18n>
{
	"en": {
		"create_rec": "Create Record",
		"end": "End",
		"end_rec": "End the recording manually",
		"new_rec": "New Record",
		"or": "OR",
		"rec_name": "Record Name",
		"start": "Start",
		"start_rec": "Start the recording manually"
	},
	"fr": {
		"create_rec": "Créer un enregistrement",
		"end": "Finir",
		"end_rec": "Terminer l'enregistrement manuellement",
		"new_rec": "Nouvel enregistrement",
		"or": "OU",
		"rec_name": "Nom de l'enregistrement",
		"start": "Début",
		"start_rec": "Démarrer l'enregistrement manuellement"
	},
	"sw": {
		"create_rec": "Unda Rekodi",
		"end": "Mwisho",
		"end_rec": "Maliza kurekodi mwenyewe",
		"new_rec": "Rekodi Mpya",
		"or": "au",
		"rec_name": "Jina la Rekodi",
		"start": "Anza",
		"start_rec": "Anza kurekodi mwenyewe"
	}
}
</i18n>